const state = {
  wj: {},
  currentIndex: 0
}

const mutations = {
  SET_DATA(state, wj) {
    if (state.wj.id !== wj.id) {
      state.wj = wj
      state.currentIndex = 0
    }
  },
  NEXT(state, num) {
    state.currentIndex += num
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
